import { id, root } from './hardware-locations';

export const hardwareLocations = {
  ...root,
  id,
};
